import React, { useState } from "react";
import "./inputfields.css";

function InputTextField(props) {
  const [focused, setFocused] = useState(false);
  const {
    width,
    padding,
    height,
    label,
    errorMessage,
    required,
    onChange = () => { },
    icon,
    bg,
    type,
    alignItem = "center", 
    ...inputProps
  } = props;

  const handleFocus = () => {
    setFocused(true);
  };

  const handleChange = (event) => {
    const { value } = event.target;
    // Validate the date input to ensure year is exactly 4 digits
    if (type === 'date') {
      const datePattern = /^\d{4}-\d{2}-\d{2}$/;
      const yearPattern = /^\d{4}$/;
      const parts = value.split('-');

      if (parts.length === 3 && yearPattern.test(parts[0]) && datePattern.test(value)) {
        onChange(event);
      } else if (parts.length < 3) {
        onChange(event);
      }
    } else {
      onChange(event);
    }
  };

  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 80;
  const maxYear = currentYear - 14;

  return (
    <div 
      className="input-text-field" 
      style={{ alignItems: alignItem }} /* Dynamically set alignItems */
    >
      <label>
        {label}
        {required && <span>*</span>}
      </label>

      {type === "textarea" ? (
        <textarea
          {...inputProps}
          onChange={handleChange}
          onBlur={handleFocus}
          onFocus={handleFocus}
          focused={focused.toString()}
          style={{ height, padding, width, backgroundColor: bg }}
        />
      ) : (
        <input
          {...inputProps}
          onChange={handleChange}
          onBlur={handleFocus}
          onFocus={handleFocus}
          focused={focused.toString()}
          style={{ height, padding, width, backgroundColor: bg }}
          min={`${minYear}-01-01`}
          max={`${maxYear}-12-31`}
        />
      )}
    </div>
  );
}

export default InputTextField;
